import React from "react"
import { SvgIcon } from "@material-ui/core"

function ControllerIcon(props) {
  return (
    <SvgIcon {...props}>
      <path d="M21.5801 16.09L20.4901 8.43C20.2101 6.46 18.5201 5 16.5301 5H7.47007C5.48006 5 3.79007 6.46 3.51007 8.43L2.42007 16.09C2.20007 17.63 3.39007 19 4.94007 19C5.62007 19 6.26007 18.73 6.74007 18.25L9.00007 16H15.0001L17.2501 18.25C17.7301 18.73 18.3801 19 19.0501 19C20.6101 19 21.8001 17.63 21.5801 16.09ZM11.0001 11H9.00007V13H8.00007V11H6.00007V10H8.00007V8H9.00007V10H11.0001V11ZM15.0001 10C14.4501 10 14.0001 9.55 14.0001 9C14.0001 8.45 14.4501 8 15.0001 8C15.5501 8 16.0001 8.45 16.0001 9C16.0001 9.55 15.5501 10 15.0001 10ZM17.0001 13C16.4501 13 16.0001 12.55 16.0001 12C16.0001 11.45 16.4501 11 17.0001 11C17.5501 11 18.0001 11.45 18.0001 12C18.0001 12.55 17.5501 13 17.0001 13Z" />
    </SvgIcon>
  )
}

export default ControllerIcon
